module.exports = __webpack_public_path__ + "static/media/orangetriangle.7c6dc123.png";